import QBModel from './QBModel'

 export const getAllColumns = function (entity) {
   return QBModel.columns[entity];
 }
 export const getHqlQuery = function (entity, filters) {
        const allColumns = QBModel.columns[entity];
        if (filters.length > 0) {
          let conditionsStatement = filters.map(
            (filter, index) => {
              let statement =
                index > 0
                  ? `${filter.andOrOr} ${filter.column}`
                  : `${filter.column}`;
              if (
                ["equal", "not equal", "greater than", "less than"].includes(
                  filter.filter
                ) &&
                colType(allColumns,filter.column) === "NUMERIC"
              ) {
                statement = `${statement} ${
                  operators[filter.filter]
                } ${fixNumberFormat(filter.inputField1)}`;
                return statement;
              } else if (
                ["equal", "not equal"].includes(filter.filter) &&
                colType(allColumns,filter.column) === "CHARACTER"
              ) {
                statement = `${statement} ${
                  operators[filter.filter]
                } '${filter.inputField1}'`;
                return statement;
              } else if (
                ["like"].includes(filter.filter) &&
                colType(allColumns,filter.column) === "CHARACTER"
              ) {
                statement = `${statement} ${
                  operators[filter.filter]
                } '%${filter.inputField1}%'`;
                return statement;
              } else if (
                ["equal", "not equal", "greater than", "less than"].includes(
                  filter.filter
                ) &&
                (colType(allColumns,filter.column) === "DATE" || colType(allColumns,filter.column) === "SIMPLEDATE")
              ) {
                statement = `${statement} ${
                  operators[filter.filter]
                } '${filter.datePicker1}'`;
                return statement;
              } else if (
                ["older than", "newer than"].includes(
                  filter.filter
                ) &&
                (colType(allColumns,filter.column) === "DATE" || colType(allColumns,filter.column) === "SIMPLEDATE" || colType(allColumns,filter.column) === "DATETIME")
              ) {
                const newDate = new Date();
                newDate.setDate(newDate.getDate() + parseInt(filter.inputField1));
                let sDate = newDate.toISOString().split("T")[0];

                statement = `${statement} ${
                  operators[filter.filter]
                } '${sDate}'`;
                return statement;
              } else if (
                filter.filter === "between" &&
                (colType(allColumns,filter.column) === "DATE" || colType(allColumns,filter.column) === "SIMPLEDATE")
              ) {
                statement = `${statement} ${
                  operators[filter.filter]
                } '${filter.datePicker1}' and '${filter.datePicker2}'`;
                return statement;
              } else if (
                ["equal", "not equal", "greater than", "less than"].includes(
                  filter.filter
                ) &&
                colType(allColumns,filter.column) === "TIME"
              ) {
                statement = `${statement} ${
                  operators[filter.filter]
                } '${filter.timePicker1}'`;
                return statement;
              } else if (
                filter.filter === "between" &&
                colType(allColumns,filter.column) === "TIME"
              ) {
                statement = `${statement} ${
                  operators[filter.filter]
                } '${filter.timePicker1}' and '${filter.timePicker2}'`;
                return statement;
              } else if (
                ["equal", "not equal", "greater than", "less than"].includes(
                  filter.filter
                ) &&
                colType(allColumns,filter.column) === "DATETIME"
              ) {
                statement = `${statement} ${
                  operators[filter.filter]
                } '${filter.datePicker1} ${filter.timePicker1}'`;
                return statement;
              } else if (
                filter.filter === "between" &&
                colType(allColumns,filter.column) === "DATETIME"
              ) {
                statement = `${statement} ${
                  operators[filter.filter]
                } '${filter.datePicker1} ${filter.timePicker1}' and '${
                  filter.datePicker2
                } ${filter.timePicker2}'`;
                return statement;
              } else if (
                filter.filter === "between" &&
                colType(allColumns,filter.column) === "NUMERIC"
              ) {
                statement = `${statement} ${
                  operators[filter.filter]
                } '${fixNumberFormat(filter.inputField1)}' and '${fixNumberFormat(filter.inputField2)}'`;
                return statement;
              } else if (filter.filter === "in") {
                statement = `${statement} ${
                  operators[filter.filter]
                } (${filter.fileContent})`;
                return statement;
              } else if (filter.filter === "is null" || filter.filter === "is not null") {
                statement = `${statement} ${
                  operators[filter.filter]
                }`;
                return statement;
              }
            }
          );
          return (
            conditionsStatement.join("\n")
          );
        }
        return "";
      }

      /*
 const getRawQuery = function(entity, allColumns, selectedColumns, filters, maxRows) {
        const selectedFields = selectedColumns.map(column => column.field);

    const selectStatement =
        (selectedColumns.length === allColumns.length
          ? "SELECT *"
          : `SELECT ${selectedFields.map(col => `${col}`).join(", ")}`) +
            `\nFROM ${entity}`;
      if (filters.length > 0) {
        let conditionsStatement = filters.map(
          (filter, index) => {
            let statement =
              index > 0
                ? `${filter.andOrOr} ${filter.column}`
                : `${filter.column}`;
            if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              colType(allColumns,filter.column) === "NUMERIC"
            ) {
              statement = `${statement} ${
                operators[filter.filter]
              } ${filter.inputField1}`;
              return statement;
            } else if (
              ["equal", "not equal"].includes(filter.filter) &&
              colType(allColumns,filter.column) === "CHARACTER"
            ) {
              statement = `${statement} ${
                operators[filter.filter]
              } '${filter.inputField1}'`;
              return statement;
            } else if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              (colType(allColumns,filter.column) === "DATE" || colType(allColumns,filter.column) === "SIMPLEDATE")
            ) {
              statement = `${statement} ${
                operators[filter.filter]
              } '${filter.datePicker1}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              (colType(allColumns,filter.column) === "DATE" || colType(allColumns,filter.column) === "SIMPLEDATE")
            ) {
              statement = `${statement} ${
                operators[filter.filter]
              } '${filter.datePicker1}' and '${filter.datePicker2}'`;
              return statement;
            } else if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              colType(allColumns,filter.column) === "TIME"
            ) {
              statement = `${statement} ${
                operators[filter.filter]
              } '${filter.timePicker1}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              colType(allColumns,filter.column) === "TIME"
            ) {
              statement = `${statement} ${
                operators[filter.filter]
              } '${filter.timePicker1}' and '${filter.timePicker2}'`;
              return statement;
            } else if (
              ["equal", "not equal", "greater than", "less than"].includes(
                filter.filter
              ) &&
              colType(allColumns,filter.column) === "DATETIME"
            ) {
              statement = `${statement} ${
                operators[filter.filter]
              } '${filter.datePicker1} ${filter.timePicker1}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              colType(allColumns,filter.column) === "DATETIME"
            ) {
              statement = `${statement} ${
                operators[filter.filter]
              } '${filter.datePicker1} ${filter.timePicker1}' and '${
                filter.datePicker2
              } ${filter.timePicker2}'`;
              return statement;
            } else if (
              filter.filter === "between" &&
              colType(allColumns,filter.column) === "NUMERIC"
            ) {
              statement = `${statement} ${
                operators[filter.filter]
              } '${filter.inputField1}' and '${filter.inputField2}'`;
              return statement;
            } else if (filter.filter === "in") {
              statement = `${statement} ${
                operators[filter.filter]
              } (${filter.fileContent})`;
              return statement;
            } else if (filter.filter === "is null" || filter.filter === "is not null") {
              statement = `${statement} ${
                operators[filter.filter]
              }`;
              return statement;
            }
          }
        );
        return (
          selectStatement +
          "\nWHERE " +
          conditionsStatement.join("\n")
          + `\nlimit ${maxRows}`
        );
      }
      return selectStatement + `\nlimit ${maxRows}`;
}
*/
const colType = function (allColumns,field) {
    if (field) {
      const colData = allColumns.find(item => item.field === field);
      return colData.type;
    }
  }

 const fixNumberFormat = function (value) {
    try {
        if (value.indexOf('.')>=0 || value.indexOf(',')>=0) {
            return parseFloat(value);
        }

        return parseInt(value);
    }
    catch (e) {
        console.log(e);
    }

    return value;

}
export const operators = {
    "greater than": ">",
    "less than": "<",
    equal: "=",
    "not equal": "<>",
    in: "in",
    between: "between",
    'is null': 'is null',
    'is not null': 'is not null',
    "newer than": ">",
    "older than": "<",
    "like": "like",
  }
 